<template>
    <td-dialog :title="$t(title)" :visible.sync="dialogVisible" :width="addDialogWidth + 'px'" :before-close="cancel" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form :model="networkForm" ref="networkForm" class="demo-form-inline" :label-width="modifyDevInfoFormLabelWidth + 'px'" @submit.native.prevent :rules="rules">
            <el-form-item :label="$t('pgCommon.NETWORK_NAME')" prop="sName">
                <td-input v-model="networkForm.sName" maxlength="50"></td-input>
            </el-form-item>
            <el-form-item :label="$t('pgCommon.FLATFORM_IP')" prop="sAddress">
                <td-input v-model="networkForm.sAddress" maxlength="50"></td-input>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <td-button type="primary" :loading="saveLoading" @click="submitForm()">{{ $t('common.SAVE') }}</td-button>
            <td-button @click="cancel">{{ $t('common.CANCAL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import api from './api.js';
export default {
    props: {
        title: {
            type: String,
            defalut: ''
        },
        dialogVisible: {
            type: Boolean,
            defalut: function() {
                return false;
            }
        },
        networkForm: {
            type: Object,
            defalut: function() {
                return { sName: '', sAddress: '' };
            }
        },
        addOrEdit: {
            type: String,
            defalut: 'add'
        }
    },
    computed: {
        fontsize() {
            return window.vue.$store.state.fontSize;
        }
    },
    watch: {
        //观察字体大小的变化
        fontsize: {
            immediate: true,
            handler(newVal, oldVal) {
                this.addDialogWidth = Number(450 + Number(Number(newVal) == 14 ? 0 : Number(newVal) + 100));
                this.modifyDevInfoFormLabelWidth = Number(120 + Number(Number(newVal) == 14 ? 0 : Number(newVal) + 30));
            },
            deep: true //对象内部属性的监听，关键。
        }
    },
    data() {
        return {
            addDialogWidth: 450,
            modifyDevInfoFormLabelWidth: 120,
            saveLoading: false,
            rules: {
                sName: [
                    { required: true, message: this.$t('pgError.ERROR_PLEASE_INPUT_NETWORK_NAME'), trigger: 'blur' },
                    { pattern: this.$regex.CAPTION_RULE, message: this.$t('pgRegex.PLEASE_INPUT_CREDENT_NUM_RESET') }
                ],
                sAddress: [
                    { required: true, message: this.$t('pgError.ERROR_PLEASE_INPUT_NETWORK_IP'), trigger: 'blur' },
                    { pattern: this.$regex.CAPTION_RULE, message: this.$t('pgRegex.PLEASE_INPUT_CREDENT_NUM_RESET') }
                ]
            }
        };
    },
    methods: {
        /**关闭按钮触发的方法 */
        cancel() {
            this.$emit('dialogClose');
        },
        /**保存成功后调用父页面的方法 */
        refreshData() {
            this.$emit('refreshData');
        },
        /**保存按钮触发的方法 */
        submitForm() {
            this.$refs.networkForm.validate(valid => {
                if (valid) {
                    this.saveLoading = true;
                    if (this.addOrEdit == 'add') {
                        api.addNetworkSettings(this.networkForm, response => {
                            this.saveLoading = false;
                            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('/networkSetting/addNetworkSettings', response);
                                return;
                            }
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'success' });
                            this.cancel();
                            this.refreshData();
                        });
                    }
                    if (this.addOrEdit == 'edit') {
                        api.updateNetworkSettings(this.networkForm, response => {
                            this.saveLoading = false;
                            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('/networkSetting/updateNetworkSettings', response);
                                return;
                            }
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'success' });
                            this.cancel();
                            this.refreshData();
                        });
                    }
                }
            });
        }
    }
};
</script>
